import { useWebTranslation } from "translations";
import {
  CHAT_MESSAGE_DISPLAY_NAME,
  MessageTransition,
} from "ui-kit/ChatMessage/ChatMessage";
import { Typography } from "ui-kit/Typography";
import styles from "./CancellationDisclaimer.module.css";

export const CancellationDisclaimer = ({
  index,
  transitioning,
  competitorName,
}: {
  index?: number;
  transitioning?: boolean;
  competitorName: string;
}) => {
  const { t } = useWebTranslation();

  return (
    <MessageTransition
      fromMe={false}
      transitioning={transitioning}
      index={index}
      className={styles.container}
    >
      <Typography>
        {t("competitor.comparison.cancellation_not_possible.text_extended", {
          competitorName,
        })}
      </Typography>
    </MessageTransition>
  );
};

CancellationDisclaimer.displayName = CHAT_MESSAGE_DISPLAY_NAME;
